import { SectionContent } from '../SectionContent';
import { SectionHeader } from '../SectionHeader';
import { Container } from './styled';
export function Section(props) {
    const { id, title, actions, children } = props;
    return (<Container value={id}>
      <SectionHeader title={title} actions={actions}/>
      <SectionContent>{children}</SectionContent>
    </Container>);
}
